export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";